/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const ArrowDownSolidV6 = (props) => (
  <Icon {...props} name="Arrow Down Solid V6">
    <path d="m13.706 9.706-5 5a.997.997 0 0 1-1.413.001l-5-5a.999.999 0 1 1 1.414-1.414L7 11.588V2c0-.553.448-.972.972-.972S9 1.447 9 2v9.588l3.294-3.294a.999.999 0 1 1 1.412 1.412z" />
  </Icon>
);

export default ArrowDownSolidV6;
